export const UTENOS_PREKYBA = "Utenos prekyba";
export const JARAJUMS = "JaraJums";
export const SVAITA = "Svaita";
export const TAXCUBE = "TaxCube";


// WEBPACK FOOTER //
// ./src/constants/companies.js